import { FeatureMouseInteraction } from '@shared/openlayers/interaction/FeatureMouseInteraction';
import { setMapCursor } from '@openlayers/ol-utils';
import Feature from 'ol/Feature';
import { showTekPointSoilSurvey } from '@pages/soil-survey/soil-survey-main';
import { SURVEY_TYPE_TITLES } from '@pages/soil-survey/soil-survey-constants';


export class TekPointDesktopMouseInteraction extends FeatureMouseInteraction {
    onClick = (feature: Feature, e, n, featuresAtPixel: Feature[]): void => {
        // Direct click behavior - open graph or raw data window
        if (featuresAtPixel.length > 0) {
            const clickedFeature = featuresAtPixel[0];
            const pointData = clickedFeature.get('data');
            this.handleTekPointClick(pointData);
        }
    };

    handleTekPointClick(pointData: any) {
        const props = pointData.props || pointData;
        const tt = props['tutkimustapa'];

        if (!tt) {
            console.warn('No TT found in point data');
            return;
        }

        const parsedValue = tt.split(/[\s-]/)[0];
        const title = SURVEY_TYPE_TITLES[parsedValue];

        // Always pass the full point data including both props and the point itself
        showTekPointSoilSurvey({
            ...props,
            title,
            point: pointData,
        });
    }

    onMouseOver = (feature: Feature): void => {
        if (!feature.get('isLinePoint')) {
            setMapCursor(this.map, 'pointer');
        }
    };
}
